module.exports = __webpack_public_path__ + "img/r-49.cb6b2634.jpg";